import styled, { css } from 'styled-components';
import { colors, spacing, body2, fontSizes } from 'ui/theme';
import { SecondaryButton, GhostButton } from 'ui/button';

export const FileAcceptancePrompt = styled.p`
  ${body2}
  color: ${colors.textSecondary};
  font-size: ${fontSizes.s12};
`;

export const Prompt = styled.div`
  ${body2}
  color: ${colors.textSecondary};
  margin: 0;
`;

export const ErrorMessageWrapper = styled.div`
  display: flex;
  gap: ${spacing.half};
  align-items: center;
  color: ${colors.textPrimary};
`;

const focusedCss = css`
  border-color: ${colors.purple50};
  background-color: ${colors.purple10};
  > ${FileAcceptancePrompt}, > ${Prompt} {
    color: ${colors.purple50};
  }
`;

const getBackgroundAndBorderColors = (props: any) => {
  if (props.isDragAccept || props.isFocused) {
    return focusedCss;
  }
  if (props.isDragReject) {
    return css`
      border-color: ${colors.red50};
      background-color: ${colors.red10};
    `;
  }

  return css`
    background-color: ${colors.grey1};
    border-color: ${colors.grey15};
  `;
};

export const AcceptedFileContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

export const Container = styled.div`
  display: flex;
  gap: ${spacing.base};
  padding: ${spacing.plusHalf};
  flex-direction: column;
  align-items: center;
  border-width: ${spacing.single};
  border-radius: ${spacing.quarter};
  border-style: dashed;

  ${(props) => getBackgroundAndBorderColors(props)};
  &[data-has-file-rejections='true'] {
    border: ${spacing.eighth} solid ${colors.borderDestructive};
    background-color: ${colors.backgroundDestructiveSubtle};
  }

  &:focus-within {
    ${focusedCss}
  }
`;

export const StyledGhostButton = styled(GhostButton)`
  padding-left: ${spacing.half};
  padding-right: ${spacing.half};
`;

export const StyledSecondaryButton = styled(SecondaryButton)`
  gap: ${spacing.half};
`;
